import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { GAPersonalChangePasswordBtnClick, GAPersonalChangeAppearanceClick, GAPersonalFeedbackBtnClick } from "../../../../../ga/personalCenter";

const SettingRender = ({ handleChangePasswordModalVisible, handleChangeAppearanceModalVisible, handleFeedbackModalVisible }) => {
  const { t } = useTranslation(["personalCenterSetting"]);
  return (
    <div className="setting">
      <div className="mb-5 pb-2">
        <h4 className="fw-bold mb-2">{t("passwordTitle")}</h4>
        <p className="mb-3">{t("changePasswordTips")}</p>
        <Button
          onClick={() => {
            handleChangePasswordModalVisible(true);
            GAPersonalChangePasswordBtnClick();
          }}
        >
          {t("changePasswordBtn")}
        </Button>
      </div>
      <div className="mb-5 pb-2">
        <h4 className="fw-bold mb-2">{t("feedbackTitle")}</h4>
        <p className="mb-3">{t("feedbackTips")}</p>
        <Button
          onClick={() => {
            handleFeedbackModalVisible(true);
            GAPersonalFeedbackBtnClick();
          }}
        >
          {t("feedbackBtn")}
        </Button>
      </div>
      <div>
        <h4 className="fw-bold mb-2">{t("appearanceTitle")}</h4>
        <p className="mb-3">{t("appearanceTips")}</p>
        <Button
          onClick={() => {
            handleChangeAppearanceModalVisible(true);
            GAPersonalChangeAppearanceClick();
          }}
        >
          {t("appearanceBtn")}
        </Button>
      </div>
    </div>
  );
};
export default SettingRender;
